/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorSource from './tumor-source';
import TumorSourceDetail from './tumor-source-detail';
import TumorSourceUpdate from './tumor-source-update';
import TumorSourceDeleteDialog from './tumor-source-delete-dialog';

const TumorSourceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorSource />} />
    <Route path="new" element={<TumorSourceUpdate />} />
    <Route path=":id">
      <Route index element={<TumorSourceDetail />} />
      <Route path="edit" element={<TumorSourceUpdate />} />
      <Route path="delete" element={<TumorSourceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorSourceRoutes;
